// let observer = {
//   methods: {},
// }
function observer () {
  this.methods = {}
}

observer.prototype.onlyon = function (key, method) {
  this.methods[key] = method
}

observer.prototype.onlyemit = function (key, params = null) {
  this.methods[key] && this.methods[key](params)
}
observer.prototype.off = function (key) {
  this.methods[key] = null
}
observer.prototype.offall = function () {
  this.methods = null
}

class SaveScroll {
  constructor () {
    this.currentKey = ''
    this.marks = null
    this.keys = []
    this.success = false
    this.offsetTops = null
    this.indexOfDistance = []
    this.boxDistanceTop = 0
    this.ids = []
  }

  dispatchClick (key) {
    if (this.success) return
    this.currentKey = key
    this.marks = [key]
  }

  dispatchListenerScroll () {
    if (this.success) return
    this.marks = ['Listener']
  }

  dispatchUpdate (refs, state) {
    if (!this.success && this.marks && state) {
      this.dealScrollTop(refs)
    }
  }

  initData (boxDom) {
    // this.initTopDistance(this.ids, boxDom)
    this.initTopDistance(this.currentType)
    let offsetTops = {}
    let indexOfDistance = []
    // let boxDom = boxRef.current
    // console.log(boxDom, '=====')
    // console.log(this.keys)
    // console.log(boxDom, '=====')
    // let boxDom = reff.current
    this.keys.forEach((v, i) => {
      let distance = boxDom?.querySelector('#' + v)?.offsetTop || 0
      distance += this.boxDistanceTop
      // distance += 17
      offsetTops[v] = distance 
      indexOfDistance.push(distance)
    })
    // console.log(offsetTops)
    this.offsetTops = offsetTops
    this.indexOfDistance = indexOfDistance
    return {
      offsetTops,
      indexOfDistance
    }
  }

  // 
  initTopDistance (key) {
    // let boxTop = boxRef.offsetTop
    // console.log(ids, boxTop)
    // console.log(document.getElementById(ids[0]).offsetHeight)
    // console.log(document.getElementById(ids[1]).offsetHeight)
    // let fixedHeight = ids.reduce((acc, id) => acc + document.getElementById(id).offsetHeight, 0)
    // this.boxDistanceTop = boxTop - fixedHeight
    switch (key) {
      case 'doc':
        this.boxDistanceTop = 0
        break
      case 'hos':
        this.boxDistanceTop = 24
        break
      case 'dep':
        this.boxDistanceTop = -30
        break
      default:
        this.boxDistanceTop = 0
        break
    }
    // this.boxDistanceTop = document.getElementById(ids[1]).offsetHeight - fixedHeight
    // return boxTop - fixedHeight
  }

  saveTopIds (ids, key) {
    // console.log('000000000000', {ids})
    this.ids = ids
    this.currentType = key

  }

  dealScrollTop (boxDom) {
    const { offsetTops } = this.initData(boxDom)
    // let offsetTops = {}
    // let indexOfDistance = []
    // let boxDom = boxRef.current
    // console.log(boxDom, '=====')
    // console.log(this.keys)
    // console.log(boxDom, '=====')
    // // let boxDom = reff.current
    // this.keys.forEach((v, i) => {
    //   let distance = boxDom?.querySelector('#' + v).offsetTop || 0
    //   offsetTops[v] = distance
    //   indexOfDistance.push(distance)
    // })
    // console.log(offsetTops)
    // this.offsetTops = offsetTops
    // this.indexOfDistance = indexOfDistance
    this.doScrollTop(offsetTops[this.currentKey])
    this.resetState()
  }

  doScrollTop (top) {
    window.scrollTo({
      top: top,
      behavior: 'instant',
    })
  }

  resetState () {
    this.marks = null
    this.success = true
  }

  getOffsetTops () {
    return this.offsetTops
  }

  getIndexOfDistance () {
    return this.indexOfDistance
  }

  saveKeys (keys, keyName = '') {
    this.keys = keyName ? keys.map((v) => v[keyName]) : keys
  }

}

const newObserver = new observer()

export {
  SaveScroll
} 

export default newObserver
